import PageHero from "@/components/PageHero";
import ServicesSection from "@/sections/ServicesSection";
import ApproachTimeline from "@/sections/ApproachTimeline";
import CTABlock from "@/components/CTABlock";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        testId="services-hero"
        label="Services"
        title="End-to-end solutions for"
        accent="modern service businesses."
        subtitle="We combine strategy, design, automation, and operational systems to build a connected growth engine around the business — from first positioning decision to fully operational infrastructure."
      />
      <ServicesSection withHeader={false} />
      <ApproachTimeline />
      <CTABlock />
    </div>
  );
}
